<template>
  <CommonModal
    title="TOP10商家明细（商家账号维度）"
    :width="800"
    :footer="null"
    :visible="topUserVisible"
    :bodyStyle="{ padding: '20px' }"
    @cancel="closeModal"
  >
    <a-table :columns="columns" :data-source="topUser" :pagination="false" size="middle" rowKey="loginName" />
    <div style="display: flex; justify-content: center; margin-top: 28px; margin-bottom: 8px;">
      <a-button type="primary" @click="closeModal">我知道了</a-button>
    </div>
  </CommonModal>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import CommonMixin from '@/mixins/global'
  import { mapState, mapActions } from 'vuex'
  import CommonModal from '@/components/common-modal'
  import { Button, Table } from 'ant-design-vue'
  export default {
    name: "top-user-modal",
    components: {
      CommonModal,
      [Table.name]: Table,
      [Button.name]: Button,
    },
    mixins: [ CommonMixin ],
    computed: {
      ...mapState('heatmap', ['topUser', 'topUserVisible', 'period']),
      columns: function() {
        let useTimesTitle = '使用次数'
        if (this.period === 30) {
          useTimesTitle += '(近30天)'
        } else if (this.period === 7) {
          useTimesTitle += '(近7天)'
        } else if (this.period === 1) {
          useTimesTitle += '(昨日)'
        } 
        return [{
          title: '序号',
          dataIndex: 'index',
          align: 'center'
        }, {
          title: '商家账号',
          dataIndex: 'loginName',
          align: 'center'
        }, {
          title: '商家名称',
          dataIndex: 'businessName',
          align: 'center'
        }, {
          title: useTimesTitle,
          dataIndex: 'pv',
          align: 'center'
        }]
      }
    },
    
    methods: {
      ...mapActions('heatmap', ['handleTopUserModalVisible']),
      closeModal() {
        this.handleTopUserModalVisible(false)
      }
    }
  }
</script>
